import con from '../../../../connection';
var path = '/occupations';
export var occupations = function (url) { return function () { return ({
    get: con.get(url + path, {}),
}); }; };
